// import React, { useEffect, useState } from "react";
// import { CustomMultiSelect } from "../../components/CustomMultiSelect/CustomMultiSelect";
// import { PurposeIcon } from "../../../../assets/icons/PurposeIcon";
// import { Input } from "../../components/Input/Input";
// import styles from "./SettingsModule.module.scss";
// import { TableIcon } from "../../../../assets/icons/TableIcon";
// import { InputTextIcon } from "../../../../assets/icons/InputTextIcon";
// import { ToggleSwitch } from "../../ui/ToggleSwitcher/ToggleSwitcher";
// import { Button } from "../../ui/Button/Button";
// import { SlidersIcon } from "../../../../assets/icons/SlidersIcon";
// import Slider from "../../ui/Slider/Slider";
// import { useDispatch } from "react-redux";
// import { setNewAssistant } from "../../../../store/slices/assistantSlice";
// import { AnswerTab } from "../../components/AnswerTab/AnswerTab";
// import { TimerIcon } from "../../../../assets/icons/TimerIcon";
// import { Textarea } from "../../components/Textarea/Textarea";

// const answerData = ["Короткий", "Средний", "Длинный"];

// const sliders = [
//   {
//     title: "Температура",
//     min: 0.01,
//     max: 2,
//     step: 0.01,
//     value: "temperature",
//   },
//   {
//     title: "Макс. токенов",
//     min: 1,
//     max: 4095,
//     step: 1,
//     value: "maxLength",
//   },
// ];

// export const SettingsModule = ({ newAssistant }) => {
//   const dispatch = useDispatch();

//   const answerLength = newAssistant?.answerLength || "Короткий";
//   const selectedTemplate = newAssistant?.selectedTemplate || null;
//   const splitMessage = newAssistant?.splitMessage || false;

//   const [moreSettings, setMoreSettings] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (
//       JSON.stringify(newAssistant.settings.instruction) !==
//       JSON.stringify(selectedTemplate)
//     ) {
//       if (selectedTemplate) {
//         dispatch(
//           setNewAssistant({
//             ...newAssistant,
//             settings: {
//               ...newAssistant.settings,
//               instruction: selectedTemplate,
//             },
//           })
//         );
//       }
//     }
//   }, [dispatch, newAssistant, selectedTemplate]);

//   const handleSetMoreSettings = (bool) => {
//     setMoreSettings(bool);
//   };

//   const handleSetAnswerLength = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       answerLength: value,
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlePurposeChange = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       purpose: value,
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlerGRPCPortAssistant = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       settings: {
//         ...newAssistant.settings,
//         grpcServicePort: value,
//       },
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlerResponseDelay = (value) => {
//     if (value < 15) {
//       setError("Минимальное значение 15");
//     } else {
//       setError(null);
//     }

//     const updatedAssistant = {
//       ...newAssistant,
//       responseDelay: value,
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlerApiPortAssistant = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       settings: {
//         ...newAssistant.settings,
//         apiServicePort: value,
//       },
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const sliderObserver = (val, name) => {
//     if (newAssistant) {
//       const updatedAssistant = {
//         ...newAssistant,
//         settings: {
//           ...newAssistant.settings,
//           [name]: Number(val),
//         },
//       };

//       dispatch(setNewAssistant(updatedAssistant));
//     }
//   };

//   const toggleReminderObserver = (bool) => {
//     if (!newAssistant) return;

//     const updatedAssistant = {
//       ...newAssistant,
//       settings: {
//         ...newAssistant.settings,
//         useReminder: bool,
//       },
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const toggleSplitMessage = (bool) => {
//     if (!newAssistant) return;
//     const updatedAssistant = {
//       ...newAssistant,
//       splitMessage: bool,
//     };
//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   console.log('new settings', newAssistant.settings.instruction);

//   const handlerChangeInstruction = (e) => {
//     if (!newAssistant) return;
//     const updatedAssistant = {
//       ...newAssistant,
//       settings: {
//         ...newAssistant.settings,
//         instruction: e.target.value,
//       },
//     };
//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.container}>
//         <div className={styles.item}>
//           <div className={styles.title}>
//             <div className={styles.icon}>
//               <PurposeIcon size={16} fill={"#212121"} />
//             </div>
//             <p>Цель</p>
//           </div>
//           <Input
//             onChange={handlePurposeChange}
//             value={newAssistant?.purpose ? newAssistant?.purpose : ""}
//             placeholder={"Цель ассистента"}
//             smallText={
//               "Укажите, какой результат вы ожидаете от общения с пользователем. Например: «получить контактные данные», «записать на консультацию», «продать товар», «ответить на вопрос» и т.д."
//             }
//           />
//         </div>

//         <div className={styles.item}>
//           <div className={styles.title}>
//             <div className={styles.icon}>
//               <TableIcon size={16} fill={"#212121"} />
//             </div>
//             <p>Выбрать данные</p>
//           </div>
//           <CustomMultiSelect />
//         </div>
//       </div>

//       <div className={styles.container} style={{ alignItems: "start" }}>
//         <div className={styles.item}>
//           <div className={styles.title}>
//             <div className={styles.icon}>
//               <InputTextIcon size={16} fill={"#212121"} />
//             </div>
//             <p>Длина ответа</p>
//           </div>
//           <div className={styles.answerTabsContainer}>
//             <div className={styles.answerTabs}>
//               {answerData.map((item) => (
//                 <AnswerTab
//                   key={item}
//                   value={item}
//                   active={item === answerLength}
//                   onClick={() => handleSetAnswerLength(item)}
//                 />
//               ))}
//             </div>
//             <small style={{ padding: 0 }}>
//               Определяет, насколько развернутыми будут ответы ассистента.
//               Короткие — по существу, длинные — с пояснениями и деталями.
//             </small>
//           </div>
//         </div>
//         <div className={styles.item}>
//           <div className={styles.title}>
//             <div className={styles.icon}>
//               <TimerIcon size={16} fill={"#212121"} />
//             </div>
//             <p>Задержка ответа</p>
//           </div>
//           <div className={styles.answerTabs}>
//             <Input
//               type="number"
//               name="responseDelay"
//               placeholder="Задержка ответа, сек."
//               onChange={handlerResponseDelay}
//               value={newAssistant?.responseDelay || ""}
//               smallText={
//                 "Задержка перед ответом в секундах. Используется для имитации “набора текста” ассистентом и создания более реалистичного общения"
//               }
//               errorText={error}
//             />
//           </div>
//         </div>
//       </div>

//       <div className={styles.container} style={{ alignItems: "start" }}>
//         <div className={styles.item}>
//           <div className={styles.toggleSwitcher}>
//             <div className={styles.switcherContainer}>
//               <ToggleSwitch
//                 bool={newAssistant?.settings?.useReminder}
//                 onToggle={toggleReminderObserver}
//               />
//               <p className={styles.switcherText}>Напоминания</p>
//             </div>
//             <small style={{ padding: 0 }}>
//               При включенной опции ассистент будет использовать напоминания
//             </small>
//           </div>
//         </div>
//         <div className={styles.item}>
//           <div className={styles.toggleSwitcher}>
//             <div className={styles.switcherContainer}>
//               <ToggleSwitch
//                 bool={splitMessage}
//                 onToggle={toggleSplitMessage}
//               />
//               <p className={styles.switcherText}>Делить сообщение</p>
//             </div>
//             <small style={{ padding: 0 }}>
//               При включении ассистент будет разбивать длинные ответы на
//               отдельные фразы и отправлять их поочерёдно, имитируя живое
//               общение.
//             </small>
//           </div>
//         </div>
//       </div>

//       <Button
//         icon={<SlidersIcon size={16} fill={"white"} />}
//         title={"Расширенные настройки"}
//         buttonStyle={styles.button}
//         titleStyle={styles.title}
//         onClick={() => handleSetMoreSettings(!moreSettings)}
//       />

//       {moreSettings && (
//         <div className={styles.card}>
//           <div className={styles.cardContainer}>
//             {sliders.map((slider) => (
//               <Slider
//                 key={slider.title}
//                 label={slider.title}
//                 min={slider.min}
//                 max={slider.max}
//                 value={newAssistant?.settings?.[slider.value] || slider.min}
//                 onChange={(val) => {
//                   sliderObserver(val, slider.value);
//                 }}
//                 step={slider.step}
//               />
//             ))}
//           </div>
//           <div className={styles.cardContainer}>
//             <Input
//               value={newAssistant?.settings?.grpcServicePort || ""}
//               onChange={handlerGRPCPortAssistant}
//               label={"GRPC-service порт"}
//               placeholder={"GRPC-service"}
//             />
//             <Input
//               value={newAssistant?.settings?.apiServicePort || ""}
//               onChange={handlerApiPortAssistant}
//               label={"API-service порт"}
//               placeholder={"API-service"}
//             />
//           </div>

//           <Textarea
//             value={newAssistant?.settings?.instruction}
//             onChange={handlerChangeInstruction}
//             placeholder={"Введите инструкцию"}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

import React, { useState } from "react";
import { CustomMultiSelect } from "../../components/CustomMultiSelect/CustomMultiSelect";
import { PurposeIcon } from "../../../../assets/icons/PurposeIcon";
import { Input } from "../../components/Input/Input";
import styles from "./SettingsModule.module.scss";
import { TableIcon } from "../../../../assets/icons/TableIcon";
import { InputTextIcon } from "../../../../assets/icons/InputTextIcon";
import { ToggleSwitch } from "../../ui/ToggleSwitcher/ToggleSwitcher";
import { Button } from "../../ui/Button/Button";
import { SlidersIcon } from "../../../../assets/icons/SlidersIcon";
import Slider from "../../ui/Slider/Slider";
import { useDispatch, useSelector } from "react-redux";
import {
  setNewAssistant,
  setUpdateAssistant,
} from "../../../../store/slices/assistantSlice";
import { AnswerTab } from "../../components/AnswerTab/AnswerTab";
import { TimerIcon } from "../../../../assets/icons/TimerIcon";
import { Textarea } from "../../components/Textarea/Textarea";

const answerData = ["Короткий", "Средний", "Длинный"];

const sliders = [
  {
    title: "Температура",
    min: 0.01,
    max: 2,
    step: 0.01,
    value: "temperature",
  },
  {
    title: "Макс. токенов",
    min: 1,
    max: 4095,
    step: 1,
    value: "maxLength",
  },
];

export const SettingsModule = ({ newAssistant }) => {
  const dispatch = useDispatch();

  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const answerLength = newAssistant?.answerLength || "Короткий";
  const splitMessage =
    updateAssistant?.settings?.splitMessage ||
    newAssistant?.splitMessage ||
    false;

  const [moreSettings, setMoreSettings] = useState(false);
  const [error, setError] = useState(null);

  const handleSetMoreSettings = (bool) => {
    setMoreSettings(bool);
  };

  const handleSetAnswerLength = (value) => {
    const updatedAssistant = {
      ...newAssistant,
      answerLength: value,
    };

    dispatch(setNewAssistant(updatedAssistant));
  };

  const handlePurposeChange = (value) => {
    const updatedAssistant = {
      ...newAssistant,
      purpose: value,
    };

    dispatch(setNewAssistant(updatedAssistant));
  };

  const handlerGRPCPortAssistant = (value) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: {
          ...newAssistant.settings,
          grpcServicePort: value,
        },
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          grpcServicePort: value,
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const handlerResponseDelay = (value) => {
    if (value < 15) {
      setError("Минимальное значение 15");
    } else {
      setError(null);
    }

    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        responseDelay: value,
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          responseDelay: Number(value),
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const handlerApiPortAssistant = (value) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: {
          ...newAssistant.settings,
          apiServicePort: value,
        },
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          apiServicePort: value,
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const sliderObserver = (val, name) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: {
          ...newAssistant.settings,
          [name]: Number(val),
        },
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          [name]: Number(val),
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const toggleReminderObserver = (bool) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        settings: {
          ...newAssistant.settings,
          useReminder: bool,
        },
      };

      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          useReminder: bool,
        },
      };

      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const toggleSplitMessage = (bool) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        splitMessage: bool,
      };
      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        settings: {
          ...updateAssistant.settings,
          splitMessage: bool,
        },
      };
      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  // Обработчик для ручного редактирования инструкции
  const handlerChangeInstruction = (e) => {
    if (!newAssistant) return;

    // Сначала обновляем инструкцию
    const updatedAssistant = {
      ...newAssistant,
      settings: {
        ...newAssistant.settings,
        instruction: e.target.value,
      },
    };

    dispatch(setNewAssistant(updatedAssistant));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {!updateAssistant && (
          <div className={styles.item}>
            <div className={styles.title}>
              <div className={styles.icon}>
                <PurposeIcon size={16} fill={"#212121"} />
              </div>
              <p>Цель</p>
            </div>
            <Input
              onChange={handlePurposeChange}
              value={newAssistant?.purpose ? newAssistant?.purpose : ""}
              placeholder={"Цель ассистента"}
              smallText={
                "Укажите, какой результат вы ожидаете от общения с пользователем. Например: «получить контактные данные», «записать на консультацию», «продать товар», «ответить на вопрос» и т.д."
              }
            />
          </div>
        )}

        {!updateAssistant && (
          <div className={styles.item}>
            <div className={styles.title}>
              <div className={styles.icon}>
                <TableIcon size={16} fill={"#212121"} />
              </div>
              <p>Выбрать данные</p>
            </div>
            <CustomMultiSelect />
          </div>
        )}
      </div>

      <div className={styles.container} style={{ alignItems: "start" }}>
        {!updateAssistant && (
          <div className={styles.item}>
            <div className={styles.title}>
              <div className={styles.icon}>
                <InputTextIcon size={16} fill={"#212121"} />
              </div>
              <p>Длина ответа</p>
            </div>
            <div className={styles.answerTabsContainer}>
              <div className={styles.answerTabs}>
                {answerData.map((item) => (
                  <AnswerTab
                    key={item}
                    value={item}
                    active={item === answerLength}
                    onClick={() => handleSetAnswerLength(item)}
                  />
                ))}
              </div>
              <small style={{ padding: 0 }}>
                Определяет, насколько развернутыми будут ответы ассистента.
                Короткие — по существу, длинные — с пояснениями и деталями.
              </small>
            </div>
          </div>
        )}
        <div className={styles.item}>
          <div className={styles.title}>
            <div className={styles.icon}>
              <TimerIcon size={16} fill={"#212121"} />
            </div>
            <p>Задержка ответа</p>
          </div>
          <div className={styles.answerTabs}>
            <Input
              type="number"
              name="responseDelay"
              placeholder="Задержка ответа, сек."
              onChange={handlerResponseDelay}
              value={
                updateAssistant?.settings?.responseDelay ||
                newAssistant?.responseDelay ||
                ""
              }
              smallText={`Задержка перед ответом в секундах. Используется для имитации "набора текста" ассистентом и создания более реалистичного общения`}
              errorText={error}
            />
          </div>
        </div>
      </div>

      <div className={styles.container} style={{ alignItems: "start" }}>
        <div className={styles.item}>
          <div className={styles.toggleSwitcher}>
            <div className={styles.switcherContainer}>
              <ToggleSwitch
                bool={
                  updateAssistant?.settings?.useReminder ||
                  newAssistant?.settings?.useReminder
                }
                onToggle={toggleReminderObserver}
              />
              <p className={styles.switcherText}>Напоминания</p>
            </div>
            <small style={{ padding: 0 }}>
              При включенной опции ассистент будет использовать напоминания
            </small>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.toggleSwitcher}>
            <div className={styles.switcherContainer}>
              <ToggleSwitch bool={splitMessage} onToggle={toggleSplitMessage} />
              <p className={styles.switcherText}>Делить сообщение</p>
            </div>
            <small style={{ padding: 0 }}>
              При включении ассистент будет разбивать длинные ответы на
              отдельные фразы и отправлять их поочерёдно, имитируя живое
              общение.
            </small>
          </div>
        </div>
      </div>

      <Button
        icon={<SlidersIcon size={16} fill={"white"} />}
        title={"Расширенные настройки"}
        buttonStyle={styles.button}
        titleStyle={styles.title}
        onClick={() => handleSetMoreSettings(!moreSettings)}
      />

      {moreSettings && (
        <div className={styles.card}>
          <div className={styles.cardContainer}>
            {sliders.map((slider) => (
              <Slider
                key={slider.title}
                label={slider.title}
                min={slider.min}
                max={slider.max}
                value={
                  updateAssistant?.settings?.[slider.value] ||
                  newAssistant?.settings?.[slider.value] ||
                  slider.min
                }
                onChange={(val) => {
                  sliderObserver(val, slider.value);
                }}
                step={slider.step}
              />
            ))}
          </div>
          <div className={styles.cardContainer}>
            <Input
              value={
                updateAssistant?.settings?.grpcServicePort ||
                newAssistant?.settings?.grpcServicePort ||
                ""
              }
              onChange={handlerGRPCPortAssistant}
              label={"GRPC-service порт"}
              placeholder={"GRPC-service"}
            />
            <Input
              value={
                updateAssistant?.settings?.apiServicePort ||
                newAssistant?.settings?.apiServicePort ||
                ""
              }
              onChange={handlerApiPortAssistant}
              label={"API-service порт"}
              placeholder={"API-service"}
            />
          </div>

          {!updateAssistant && (
            <Textarea
              value={newAssistant?.settings?.instruction || ""}
              onChange={handlerChangeInstruction}
              placeholder={"Введите инструкцию"}
            />
          )}
        </div>
      )}
    </div>
  );
};
